module.exports = __webpack_public_path__ + "img/1.07adf9a2.jpeg";